import { deriveKey, generateSalt } from './kdf'
import { encrypt, decrypt } from './records'
import { randomBytes } from './random'

const VERIFICATION_PLAINTEXT = new TextEncoder().encode('cartamodelli-v1')
const KEY_LEN = 32

export interface VaultMaterial {
  salt: Uint8Array
  wrappedDEK: Uint8Array
  verification: Uint8Array
}

export interface VaultSetupResult {
  material: VaultMaterial
  dek: Uint8Array
}

export async function setupVault(password: string): Promise<VaultSetupResult> {
  const salt = await generateSalt()
  const kek = await deriveKey(password, salt)
  const dek = randomBytes(KEY_LEN)
  const wrappedDEK = await encrypt(dek, kek)
  const verification = await encrypt(VERIFICATION_PLAINTEXT, kek)
  return {
    material: { salt, wrappedDEK, verification },
    dek,
  }
}

export async function unlockVault(password: string, material: VaultMaterial): Promise<Uint8Array> {
  const kek = await deriveKey(password, material.salt)
  let v: Uint8Array
  try {
    v = await decrypt(material.verification, kek)
  } catch {
    throw new Error('Master password errata')
  }
  const expected = VERIFICATION_PLAINTEXT
  if (v.length !== expected.length || !v.every((b, i) => b === expected[i])) {
    throw new Error('Master password errata')
  }
  return decrypt(material.wrappedDEK, kek)
}

// Riavvolge il DEK con una nuova password (nuovo salt, nuovo KEK).
// La DEK rimane invariata: tutti i record cifrati restano leggibili.
export async function rewrapVault(
  newPassword: string,
  dek: Uint8Array,
): Promise<VaultMaterial> {
  const salt = await generateSalt()
  const kek = await deriveKey(newPassword, salt)
  const wrappedDEK = await encrypt(dek, kek)
  const verification = await encrypt(VERIFICATION_PLAINTEXT, kek)
  return { salt, wrappedDEK, verification }
}
